import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText from "../../../utils/Translate"
import { IconButton, Modal, Paper } from "@mui/material"
import CodeMirror from '@uiw/react-codemirror';
import { materialLight } from "@uiw/codemirror-theme-material"
import { langs } from "@uiw/codemirror-extensions-langs"
import { languages } from "@codemirror/language-data"
import { markdown, markdownLanguage } from "@codemirror/lang-markdown"
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { javascript } from "@codemirror/lang-javascript";
import { LanguageSupport } from "@codemirror/language";
import { LanguageDescription } from "@codemirror/language";
import { useSnackbar } from "../../../utils/SnackbarContext"


export default function Publication() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [currentParameter, setCurrentParameter] = React.useState('0');

    const { showSnackbar } = useSnackbar();


    const handleDeleteModalOpen = (id: any) => {
        setOpenDeleteModal(id)
    };

    const handleDeleteModalClose = () => setOpenDeleteModal(false);


    const Modalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        maxWidth: 800,
        width: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };


    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const aifunctionid = params.get('aifunctionid');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title
    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit Publication` : 'Add Publication'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get did
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/functionpublications/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setPublicationData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create func
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/functionpublications`, {
                ...publicationData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit func
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/functionpublications/${id}`, {
                ...publicationData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    const [publicationData, setPublicationData] = useState<any>(type === 'edit' ? [] :
        {
            "function": aifunctionid || null,
            "protocol": '',
            "path": '',
            "include_children": '0',
            'enabled': '0',
        }
    )


    useEffect(() => {
        type === 'edit' && fetchData()
        console.log(publicationData);

    }, [])

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
                <Box sx={{ maxWidth: 1220, width: '90vw' }}>
                    <Paper elevation={3} sx={{ padding: 2, mb: 2 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'Publication'} /></Typography>
                        <Box sx={{ p: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                            <TextField onChange={(e) => setPublicationData({ ...publicationData, path: e.target.value !== '' ? e.target.value : null })} value={publicationData.path || ''} sx={{ width: "100%", mb: 1 }} variant="outlined" size="small" label={<TranslatedText text={'Path (excluding the prefix used to access the REST API (e.g., after /restapi/); only the path—excluding the function name)'} />} />
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
                                <FormControl sx={{ minWidth: 223, width: '33%' }}>
                                    <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Protocol'} /></InputLabel>
                                    <Select onChange={(e) => setPublicationData({ ...publicationData, protocol: e.target.value !== '' ? e.target.value : null })} value={publicationData.protocol || ''} sx={{ width: "100%" }} labelId="simple-select-label" variant="outlined" size="small" label={<TranslatedText text={'Protocol'} />}>
                                        <MenuItem value={'MCP'}>MCP</MenuItem>
                                        <MenuItem value={'API'}>API</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box sx={{ display: "flex", alignItems: "center", minWidth: 223, border: '1px solid', borderColor: 'divider', borderRadius: 1, paddingX: 1, justifyContent: 'space-between' }}>
                                    <Typography><TranslatedText text={'Publish subfolders'} /></Typography>
                                    <Switch onChange={(e) => setPublicationData({ ...publicationData, include_children: publicationData.include_children == '0' ? '1' : '0' })} checked={Boolean(+publicationData.include_children)} />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", minWidth: 223, border: '1px solid', borderColor: 'divider', borderRadius: 1, paddingX: 1, justifyContent: 'space-between' }}>
                                    <Typography><TranslatedText text={'Enabled'} /></Typography>
                                    <Switch onChange={(e) => setPublicationData({ ...publicationData, enabled: publicationData.enabled == '0' ? '1' : '0' })} checked={Boolean(+publicationData.enabled)} />
                                </Box>
                            </Box>

                        </Box>
                    </Paper>
                   
                </Box>
            </Box>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 3 }}>
                <Button onClick={() => type === "edit" ? putData(publicationData) : postData(publicationData)} variant="contained" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Save'} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to={`/function?id=${aifunctionid}&type=edit`} />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
            <Modal
                open={openDeleteModal}
                onClose={handleDeleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Modalstyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <TranslatedText text="Delete function" />
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <TranslatedText text="Are you sure you want to delete function" />
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: "space-between", paddingTop: 2 }}>
                        <Button onClick={handleDeleteModalClose}><TranslatedText text="Cancel" /></Button>
                        <Button onClick={() => console.log('delete')} color='error'><TranslatedText text="Delete" /></Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    )
}